module.exports = __webpack_public_path__ + "img/assistant_avatar.30d5ee61.svg";